import styled from "styled-components";
import ConditionalLink from "ui/router/components/ConditionalLink/ConditionalLink";

export const DropdownItemRoot = styled(ConditionalLink)`
    &:hover {
        opacity: 1;
    }

    .Typography {
        color: unset;
    }
`;
